import { bubble } from '../../../js/utils/bubble'

export const getInitialSelectOption = (options, value) => {
  return options.find(option => option.value === value) || options[0]
}

export const useHandleFormChange = (e, formId, ref) => {
  if (e.target.getAttribute('form') === formId) {
    bubble(ref.current, 'submit')
  }
}
